import { useConnectAccountDialog } from 'hooks/useConnectAccountDialog/useConnectAccountDialog'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useCallback } from 'react'

export interface UseConnectIntegrationTriggerProps<T = ExternalIntegrationEnum> {
  provider: T
  switchFromIntegrationId?: number
  onConnect?: (provider: T, options?: { createdIntegration?: any; shopDomain?: string }) => void
}

export const useConnectIntegrationTrigger = <T extends ExternalIntegrationEnum = ExternalIntegrationEnum>({
  provider,
  switchFromIntegrationId,
  onConnect,
}: UseConnectIntegrationTriggerProps<T>) => {
  // For TikTok and GoHighLevel, we don't use the dialog, but we still need to call the hook
  // Pass a dummy provider to satisfy React's rules of hooks
  const isDirectConnection =
    provider === ExternalIntegrationEnum.TikTok || provider === ExternalIntegrationEnum.GoHighLevel
  const { openDialog } = useConnectAccountDialog({
    provider: (isDirectConnection ? ExternalIntegrationEnum.Facebook : provider) as any,
    switchFromIntegrationId,
    onConnect: isDirectConnection ? undefined : (onConnect as any),
  } as any)

  const handleConnect = useCallback(() => {
    if (isDirectConnection) {
      // Direct connection for TikTok and GoHighLevel (no dialog)
      onConnect?.(provider)
    } else {
      // Open dialog for other providers
      // The dialog will call onConnect with the integration when it's created
      openDialog()
    }
  }, [provider, onConnect, openDialog, isDirectConnection])

  return {
    handleConnect,
  }
}
